import contentRepository from './repositories/contentRepository';
import configRepository from './repositories/configRepository';
import currencyRepository from './repositories/currencyRepository';
import languageRepository from './repositories/languageRepository';
import menuRepository from './repositories/menuRepository';
import paymentsRepository from './repositories/paymentsRepository';
import translateRepository from './repositories/translateRepository';
import countryRepository from './repositories/countryRepository';
import searchRepository from './repositories/searchRepository';

interface Response {
  get(...args: unknown[]): Promise<any>;
}

interface Repository {
  [key: string]: Response;
}

const repository: Repository = {
  content: contentRepository,
  config: configRepository,
  currency: currencyRepository,
  language: languageRepository,
  menu: menuRepository,
  translate: translateRepository,
  payments: paymentsRepository,
  country: countryRepository,
  search: searchRepository,
};

export default {
  get: (name: string | number) => repository[name],
};
